import { createBrowserRouter } from "react-router-dom";

import { CommonRoutes } from "@/app/Routes/CommonRoutes";
import { ErrorRoutes } from "@/app/Routes/ErrorRoutes";
import { JobRoutes } from "@/app/Routes/JobRoutes";
import { NodeDiagramRoutes } from "@/app/Routes/NodeDiagramRoutes";
import { ProfileRoutes } from "@/app/Routes/ProfileRoutes";
import { SettingsRoutes } from "@/app/Routes/SettingsRoutes";
import { UserRoutes } from "@/app/Routes/UserRoutes";
import { archiveRoutes } from "@/features/archive";
import { competencyRoutes } from "@/features/competency";
import { educationRoutes } from "@/features/education";
import { groupsRoutes } from "@/features/groups";
import { labRoutes } from "@/features/lab";
import { liveRoutes } from "@/features/live";
import { materialHandlingRoutes } from "@/features/material-handling";
import { measurementsRoutes } from "@/features/measurements";
import { procedureRoutes } from "@/features/procedures/routes";
import { shiftRoutes } from "@/features/shift";
import { taskRoutes } from "@/features/task";
import { trainingRoutes } from "@/features/training";
import RouteErrorBoundary from "@/shared/ui/errors/RouteErrorBoundary";

export const router = createBrowserRouter([
	{
		path: "/",
		errorElement: <RouteErrorBoundary />,
		lazy: async () => {
			const { Layout } = await import("@/app/application/Layout");
			return { Component: Layout };
		},
		children: [
			{
				index: true,
				lazy: async () => {
					const { Dashboard } = await import("@/app/application/Dashboard");
					return { Component: Dashboard };
				},
			},
			...procedureRoutes,
			...archiveRoutes,
			...CommonRoutes,
			materialHandlingRoutes,
			NodeDiagramRoutes,
			...taskRoutes,
			ErrorRoutes,
			liveRoutes,
			competencyRoutes,
			...shiftRoutes,
			labRoutes,
			UserRoutes,
			JobRoutes,
			educationRoutes,
			SettingsRoutes,
			trainingRoutes,
			groupsRoutes,
			ProfileRoutes,
			measurementsRoutes,
		],
	},
]);
